import { render, staticRenderFns } from "./Margins.vue?vue&type=template&id=248fc154&"
import script from "./Margins.vue?vue&type=script&lang=js&"
export * from "./Margins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Margins.vue
// module id = null
// module chunks = 